<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'AdminPanel',
  components: {}
}
</script>

<style scoped>

</style>
